var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRiskevaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "67.000000pt",
    height: "62.000000pt",
    viewBox: "0 0 67.000000 62.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,62.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175 554 c-40 -21 -83 -62 -103 -99 -32 -62 -15 -170 37 -229 51 -58 170 -76 237 -37 45 27 67 22 58 -14 -5 -22 3 -35 58 -91 50 -49 70 -63 84 -58 66 24 61 65 -16 138 -49 47 -65 57 -85 52 -35 -9 -39 9 -15 60 33 67 26 159 -16 211 -58 74 -168 104 -239 67z m142 -19 c48 -20 71 -41 94 -87 30 -59 26 -78 -17 -78 -24 0 -41 -6 -50 -17 -11 -16 -14 -13 -24 30 -7 26 -16 47 -20 47 -5 0 -16 -21 -26 -47 -29 -81 -32 -79 -50 32 -4 22 -10 47 -15 55 -9 17 -7 19 -32 -55 -13 -37 -17 -40 -55 -43 -37 -3 -42 -1 -42 18 0 33 25 83 56 111 52 48 118 60 181 34z m-102 -192 c16 -113 23 -117 56 -31 23 63 24 63 43 4 6 -18 8 -17 34 7 28 27 82 37 82 17 0 -24 -29 -77 -56 -102 -84 -78 -217 -58 -273 42 -33 60 -29 70 29 70 45 0 50 3 56 25 9 36 21 23 29 -32z m314 -213 c44 -52 48 -80 13 -80 -16 0 -122 99 -122 114 0 2 7 12 16 20 21 21 39 11 93 -54z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskevaluation);
export default __webpack_public_path__ + "static/media/riskevaluation.b230a853f0446d1b38c440df4dce022c.svg";
export { ForwardRef as ReactComponent };